export const httpOption = {
  apis: window._apis,
};

export const permissionConfig = {
  loadPermission: async () => {},
};
